import {FC} from "react";
import {SvgIcon} from "@mui/material";
import {TreeItem2Checkbox} from "@mui/x-tree-view";

export const CreatePlanTreeItemCheckbox: FC<any> = ({...props}) => {
  return (
    <TreeItem2Checkbox
      {...props}
      onClick={event => event.stopPropagation()}
      icon={
        <SvgIcon>
          <path
            className="tree-item-checkbox-icon-border"
            d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2z"
            stroke="grey"
            strokeWidth="2"
          />
          <path
            className="tree-item-checkbox-icon-background"
            d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2z"
            fill="white"
          />
        </SvgIcon>
      }
      checkedIcon={
        <SvgIcon>
          <path
            className="tree-item-checked-icon-border"
            d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2z"
            stroke="grey"
            strokeWidth="2"
          />
          <path
            className="tree-item-checked-icon-background"
            d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2z"
            fill="blue"
          />
          <path
            className="tree-item-checked-icon-checkmark"
            d="M10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            fill="white"
            stroke="none"
          />
        </SvgIcon>
      }
    />
  );
};
